<template>
	<div class="p-grid p-jc-center">
		<div class="card p-fluid">
			<h5>Sorry</h5>
			<p>Access to this system is prohibited.</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		}
	}
</script>

<style scoped lang="scss">

</style>
